import { library } from '@fortawesome/fontawesome-svg-core'
import { isIOS } from 'react-device-detect';
import { faCreditCard,faDice, faCommentAlt, faMoneyBillWave, faNewspaper, faWrench, faExchangeAlt, faStore  } from '@fortawesome/free-solid-svg-icons'
library.add(faCreditCard, faDice, faCommentAlt, faMoneyBillWave, faNewspaper, faWrench, faExchangeAlt, faStore)

const categories =  [
    {
        name: '去中心化金融',
        displayIos: false,
        icon: 'money-bill-wave',
        color: '#5cd879',
        dapps: [
            {
                name: 'Compound',
                url: 'https://app.compound.finance/',
                description: '用你的以太坊赚取利息',
                icon: './images/dapps/compound.finance.png'
            },
            {
                name: 'MakerDAO CDP',
                url: 'https://oasis.app/',
                description: '使用 Dai 进行交易、借贷和储蓄',
                icon: './images/dapps/cdp.makerdao.com.png'
            },
            {
                name: 'PoolTogether',
                url: 'https://app.pooltogether.com/',
                description: '这是一个与奖品挂钩的储蓄账户。通过储蓄，你有机会赢得奖品。',
                icon: './images/dapps/pooltogether.us.png'
            },
            {
                name: 'DeFi Saver',
                url: 'https://defisaver.com/',
                description: 'DeFi协议的一站式管理解决方案',
                icon: './images/dapps/defi_saver.png'
            },
            {
                name: 'pTokens',
                url: 'https://dapp.ptokens.io/',
                description: '让你的加密货币与任何区块链兼容！',
                icon: './images/dapps/pTokens.png'
            },
            {
                name: 'Zapper',
                url: 'https://zapper.fi',
                description: '在一个简洁的界面中管理你的 DeFi 资产和负债。',
                icon: './images/dapps/zapper.svg'
            },
            {
                name: 'Yearn',
                url: 'https://yearn.finance/',
                description: '一个由聚合器组成的生态系统，利用借贷服务来优化你的代币借贷。',
                icon: './images/dapps/yearn.finance.png'
            },
            {
                name: 'Aave',
                url: 'https://aave.com/',
                description: '一种开源、非托管协议，能够创建货币市场',
                icon: './images/dapps/aave.svg'
            },
            {
                name: 'Zerion',
                url: 'https://zerion.io/',
                description: 'Zerion 是构建和管理您的整个 DeFi 投资组合的最简便方法，你只需在一个地方即可完成。',
                icon: './images/dapps/zerion.io.png'
            },
            {
                name: 'Token Sets',
                url: 'https://www.tokensets.com/',
                description: '管理你的加密货币投资组合',
                icon: './images/dapps/tokensets.com.png'
            },
            {
                name: 'Pickle Finance',
                url: 'https://pickle.finance',
                description: '稳定稳定币',
                icon: './images/dapps/pickle.finance.jpeg'
            },
            {
                name: 'Nexus Mutual',
                url: 'https://nexusmutual.io/',
                description: '一种以人为本的保险替代方案',
                icon: './images/dapps/nexusmutual.io.png'
            },
            {
                name: 'Curve',
                url: 'https://www.curve.fi/',
                description: '利用先进的绑定曲线创建深度链上流动性',
                icon: './images/dapps/curve.fi.png'
            },
        ],
    },
    {
        name: '去中心化交易所',
        displayIos: false,
        icon: 'exchange-alt',
        color: '#bbb9f3',
        dapps: [
            {
                name: ' Aster',
                url: 'https://www.asterdex.com/zh-CN/referral/fC47f6',
                description: 'Aster 是一家下一代去中心化永续合约交易所。',
                icon: './images/dapps/aster.jpeg'
            },
            {
                name: ' Hyperliquid',
                url: 'https://app.hyperliquid.xyz/join/360APP',
                description: 'Hyperliquid 是一个高性能的 Layer 1 区块链平台，专门为去中心化金融（DeFi）应用程序设计，尤其是永续合约交易所。',
                icon: './images/dapps/hyperliquid.png'
            },
            {
                name: 'Uniswap',
                url: 'https://uniswap.exchange/',
                description: '交换和交易代币',
                icon: './images/dapps/uniswap.exchange.png'
            },
            {
                name: 'dYdX',
                url: 'https://trade.dydx.exchange/',
                description: '一个去中心化、非托管的交易平台，提供永续保证金和现货交易。',
                icon: './images/dapps/dydx.png'
            },
            {
                name: 'Kyber Swap',
                url: 'https://kyberswap.com/',
                description: '一种简单的代币交换方式',
                icon: './images/dapps/kyber.network.png'
            },
            {
                name: 'Tokenlon',
                url: 'https://tokenlon.im/',
                description: 'Tokenlon DEX，由 0x 协议驱动',
                icon: './images/dapps/tokenlon.png'
            },
            {
                name: '1inch',
                url: 'https://1inch.exchange',
                description: '1inch 是一个 DEX 聚合器，提供最优的 DEX 价格和 DeFi 单一入口。',
                icon: './images/dapps/1inch.svg'
            },
            {
                name: 'Totle Swap',
                url: 'https://totle.exchange',
                description: '以最优价格兑换任何 ERC-20 代币',
                icon: './images/dapps/totle.jpeg'
            },
            {
                name: 'Radar Relay',
                url: 'https://relay.radar.tech/',
                description: 'DeFi领域中，钱包间交易简单安全，价格最优。',
                icon: './images/dapps/radar_relay.png'
            },
            {
                name: 'AirSwap',
                url: 'https://instant.airswap.io/',
                description: '轻松、安全、无手续费地交易代币',
                icon: './images/dapps/instant.airswap.io.png'
            },
            {
                name: 'Balancer',
                url: 'https://balancer.exchange/#/swap',
                description: '在所有 Balancer 流动性池中无需信任即可兑换 ERC20 代币。balancer.exchange',
                icon: './images/dapps/balancer.exchange.png'
            },
            {
                name: 'Matcha',
                url: 'https://matcha.xyz/',
                description: '人人都能轻松进行加密货币交易',
                icon: './images/dapps/matcha.png'
            },
        ]   
    },
    {
        name: '艺术品和收藏品',
        displayIos: false,
        icon: 'store',
        color: '#F29D62',
        dapps: [
            {
                name: 'miime',
                url: 'https://miime.io/',
                description: 'miime是一个面向日本及全球区块链游戏玩家的NFT交易平台。',
                icon: './images/dapps/miime.png'
            },
              {
                name: 'Mintable',
                url: 'https://mintable.app',
                description: 'Mintable 是一个新一代的 NFT 交易平台，是交易 NFT 和创建自己的 NFT 的最便捷场所。',
                icon: './images/dapps/mintable.png'
            },
            {
                name: 'OpenSea',
                url: 'https://opensea.io/',
                description: '购买、出售和发现稀有数字物品',
                icon: './images/dapps/opensea.io.png'
            },
            {
                name: 'KnownOrigin',
                url: 'https://knownorigin.io/',
                description: '发现并收藏珍稀数字艺术作品',
                icon: './images/dapps/known_origin.png'
            },
            {
                name: 'Mintbase',
                url: 'https://mintbase.io',
                description: '领先的非同质化代币创建工具和市场',
                icon: './images/dapps/mintbase.png'  
            },
            {
                name: 'Axie Infinity',
                url: 'https://axieinfinity.com/#',
                description: '收集并饲养名为阿克西的奇幻生物',
                icon: './images/dapps/axieinfinity.com.png'
            },
            {
                name: 'Sorare',
                url: 'https://sorare.com/',
                description: '全球梦幻足球。收集限量版数字收藏品。',
                icon: './images/dapps/sorare.jpg'
            },
            {
                name: 'Clovers Network',
                url: 'https://clovers.network',
                description: '发现、收集和交易加密图标',
                icon: './images/dapps/clovers.png'
            },
            {
                name: 'CryptoKitties',
                url: 'https://www.cryptokitties.co/',
                description: '收集、培育和交易独一无二的加密猫',
                icon: './images/dapps/cryptokitties.co.png'
            },
            {
                name: 'Super Rare',
                url: 'https://superrare.co/',
                description: '发现并收藏数字艺术作品',
                icon: './images/dapps/superrare.co.jpg'
            },
            {
                name: 'Rarible',
                url: 'https://rarible.com/',
                description: '创建和销售数字收藏品',
                icon: './images/dapps/rarible.com.jpg'
            },
            {
                name: 'Makersplace',
                url: 'https://makersplace.com/',
                description: '收藏真正稀有的数字艺术作品',
                icon: './images/dapps/makersplace.com.jpg'
            },
            {
                name: 'My Crypto Heroes',
                url: 'https://www.mycryptoheroes.net/home',
                description: '收集并战斗英雄',
                icon: './images/dapps/my_crypto_heroes.jpg'
            },
            {
                name: 'CryptoDozer Marketplace',
                url: 'https://market.playdapp.io',
                description: '从销售到采购，该市场平台可靠且快捷。',
                icon: './images/dapps/cryptodozer.io.png'
            },
            {
                name: 'Brave Frontier Heroes',
                url: 'https://bravefrontierheroes.com',
                description: '在回合制任务和战斗中使用英雄。',
                icon: './images/dapps/brave_frontier_heroes.png'
            },
           {
                name: 'Blockchain Cuties',
                url: 'https://blockchaincuties.com/',
                description: '可爱的小家伙们是会去冒险的猫、狗和熊。',
                icon: './images/dapps/blockchaincuties.com.png'
            },
            {
                name: 'F1 Delta Time',
                url: 'https://www.f1deltatime.com/',
                description: '拥有 F1 Delta 收藏品并参与竞拍即可赢取奖励',
                icon: './images/dapps/f1deltatime.com.png'
            },
            {
                name: 'MegaCryptoPolis',
                url: 'https://mcp3d.com',
                description: '购置土地，打造区块链城市。',
                icon: './images/dapps/megacryptopolis.png'
            },
        ]   
    },
    {
        name: '发币',
        displayIos: false,
        icon: 'credit-card',
        color: '#1098FC',
        dapps: [
            {
                name: '   币代币BSC',
                url: 'https://bidaibi.com/',
                description: '在不到一分钟的时间内，使用最常用的币安智能链BEP20代币智能合约生成器创建BSC代币。',
                icon: './images/dapps/bidaibi.png'
            },
            {
                name: '  代币工厂',
                url: 'https://tokenfactory.net/',
                description: '代币工厂——一键即可在以太坊/类似以太坊的平台上发行你自己的代币。',
                icon: './images/dapps/tokenfactory.png'
            },
            {
                name: ' OP发币Optimism',
                url: 'https://op.360app.com/',
                description: '无需登录。 无需设置。 无需编程。',
                icon: './images/dapps/optimism.png'
            },
            {
                name: 'ARB发币Arbitrum',
                url: 'https://arb.360app.com/',
                description: '免费发送自己的Arbitrum代币。 ',
                icon: './images/dapps/arbitrum.png'
             },
            {
                name: 'CELO发币',
                url: 'https://celo.360app.com/',
                description: '一分钟免费发送自己的CELO代币。 ',
                icon: './images/dapps/celo.png'
             },
            {
                name: '币安链BSC发币',
                url: 'https://bsc.360app.com/',
                description: '使用最常用的币安智能链BEP20代币智能合约生成器创建BSC代币。 ',
                icon: './images/dapps/bsc.png'
             },
            {
                name: '群发吧',
                url: 'https://qunfaba.com/',
                description: '免费的代币群发工具，一次性发送上万地址。 ',
                icon: './images/dapps/qunfaba.png'
             },
            {
                name: 'Polygon发币POL',
                url: 'https://pol.360app.com/',
                description: '一分钟免费发送自己的POL代币。 ',
                icon: './images/dapps/pol.png'
             },
        ],
    },
    {
        name: '开发者工具',
        displayIos: false,
        icon: 'wrench',
        color: '#838c96',
        dapps: [
            {
                name: 'Chainlist',
                url: 'https://chainlist.org/',
                description: '一个用于向钱包添加其他区块链的网站',
                icon: './images/dapps/chainlist.png'
            },
            {
                name: 'Ethereum Name Service',
                url: 'https://app.ens.domains/',
                description: '为你的所有加密货币钱包使用同一个名称，一个去中心化的网站，以及更多',
                icon: './images/dapps/ens.jpg'
            },
            {
                name: 'Gnosis Safe Multisig',
                url: 'https://gnosis-safe.io/app/#/',
                description: '集中管理数字资产',
                icon: './images/dapps/gnosis_safe.png'
            },
            {
                name: 'Microsponsors',
                url: 'https://microsponsors.io',
                description: 'Microsponsors 是一个代币化时间的拍卖平台。',
                icon: './images/dapps/microsponsors.png'
            },
            {
                name: 'MythX',
                url: 'https://mythx.io/',
                description: '以太坊智能合约安全服务',
                icon: './images/dapps/mythx.png'
            },
        ]   
    },
    {
        name: '社交',
        displayIos: false,
        icon: 'comment-alt',
        color: '#F8CD45',
        dapps: [
            {
                name: '3Box',
                url: 'https://3box.io/hub',
                description: '以太坊社交账号',
                icon: './images/dapps/3box.io.png'
            },
            {
                name: 'Kauri',
                url: 'https://kauri.io/',
                description: '去中心化知识库中的以太坊开发者内容',
                icon: './images/dapps/kauri.io.png'
            },
            {
                name: 'FOAM',
                url: 'https://map.foam.space',
                description: '创建、整理和搜索共识驱动型地图',
                icon: './images/dapps/foam.space.png'
            },
            {
                name: 'Aragon',
                url: 'https://aragon.org/discover/',
                description: '创建和管理社区、公司、组织',
                icon: './images/dapps/aragon.org.png'
            },
        ],
    },
    {
        name: 'AI市场',
        displayIos: false,
        icon: 'newspaper',
        color: '#FF849A',
        dapps: [
            {
                name: 'Popula',
                url: 'https://popula.com/',
                description: '由 Civil 和以太坊驱动的新闻',
                icon: './images/dapps/popula.com.png'
            },
            {
                name: 'CoinDesk',
                url: 'https://www.coindesk.com/',
                description: '区块链新闻',
                icon: './images/dapps/coindesk.com.png'
            },
            {
                name: 'CoinGecko',
                url: 'https://www.coingecko.com/en',
                description: '加密货币价格与市值',
                icon: './images/dapps/coingecko.com.png'
            },
            {
                name: ' LiblibAI',
                url: 'https://liblib.cgref.cn/b',
                description: 'LiblibAI-哩布哩布AI - 国内极具影响力的AI创作平台',
                icon: './images/dapps/liblibAI.png'
            },
            {
                name: ' updream',
                url: 'https://updream.cgref.cn/b',
                description: 'updream官网-AI视频创作助手',
                icon: './images/dapps/updream.jpeg'
            },
            {
                name: ' AniShort',
                url: 'https://anishort.cgref.cn/b',
                description: 'AniShort - AI影视剧协作平台',
                icon: './images/dapps/aniShort.jpeg'
            },
            {
                name: ' 蛙蛙写作',
                url: 'https://wawawriter.cgref.cn/b',
                description: '蛙蛙写作——美团小说投稿官网_超级AI智能写作助手',
                icon: './images/dapps/wawawriter.jpeg'
            },
            {
                name: ' 码上飞',
                url: 'https://codeflying.cgref.cn/b',
                description: '码上飞CodeFlying - 跨赴科技推出的零代码AI应用开发平台',
                icon: './images/dapps/codeflying.jpeg'
            },
            {
                name: 'DeCrypt',
                url: 'https://decrypt.co/',
                description: '关于以太坊、比特币和 Web3 的新闻',
                icon: './images/dapps/decrypt.co.jpg'
            },
            {
                name: 'Defipulse',
                url: 'https://defipulse.com/',
                description: 'DeFi 分析和排名中心',
                icon: './images/dapps/defipulse.com.png'
            },
        ],
    }
];

// hide any of the above on iOS when displayIos is false
const filtered = categories.filter(({ displayIos = true }) => !(isIOS && !displayIos));

export default filtered;
